export enum CuratedSeriesListProperties {
  Name = "name",
  Description = "description",
  Series = "series",
  Active = "active",
  ReleaseZones = "releaseZones",
  Owner = "owner",
  Id = "id",
  Created = "created",
  Updated = "updated",
  Deleted = "deleted",
  Version = "version",
  ProcessedSeries = "processedSeries"
}
export enum CuratedSeriesListMetaProperties {
  ReleaseZonesId = "ReleaseZones-id",
  ReleaseZonesVersion = "ReleaseZones-version"
}
